import { atom, useAtom } from 'jotai';

import type { PlusCourseRoute } from '@/types';

export interface CourseRound {
  courseName: string;
  round: string;
  roundId: string;
}
export const infoModalAtom = atom<boolean>(false);
export const infoModalMsgAtom = atom<number>(0);
export const infoModalCourseInfoAtom = atom<CourseRound>({} as CourseRound);

type ModalState = Record<PlusCourseRoute, boolean>;

export const orientationModalAtom = atom<ModalState>({
  be: false,
  fe: false,
  ai: false,
});

export const isAlreadyPopupAtom = atom<ModalState>({
  be: false,
  fe: false,
  ai: false,
});

export const MobileGNBOpenAtom = atom<boolean>(false);

export const hasReachedFooterAtom = atom<boolean>(false);

export function useNotificationModal() {
  const [isModalOpen, setShowModal] = useAtom(infoModalAtom);
  const [modalMessage, setModalMessage] = useAtom(infoModalMsgAtom);
  const [modalCourseInfo, setModalCourseInfo] = useAtom(
    infoModalCourseInfoAtom,
  );

  function openModal() {
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
  }

  return {
    modalMessage,
    modalCourseInfo,
    isOpen: isModalOpen,
    open: openModal,
    close: closeModal,
    setOpen: setShowModal,
    setModalMessage,
    setModalCourseInfo,
  };
}
